import styled, { css } from 'styled-components';
import ColorConstants from '../../constants/ColorConstants';

const textStyle = css`
    color: ${ColorConstants['regal-blue']};
    font-size: ${({ fontSize = '12px' }) => fontSize};
    font-weight: 400;
    margin: 0;
    padding: 0;
`;

const Text = styled.span`
    ${textStyle};
`;

const Paragraph = styled.p`
    ${textStyle};
`;

const Title = styled.h1`
    ${textStyle};
    font-weight: bold;
`;

const Label = styled.label`
    ${textStyle};
    margin: 0;
    padding: 0;
`;

const Anchor = styled.a`
    text-decoration: none;
`;

export {
    Anchor,
    Label,
    Text,
    Paragraph,
    Title,
};
